import React, { useMemo, useState } from 'react';
import { Popconfirm, Form, Space, Card, Col } from 'antd';
import DeleteButton from 'components/DeleteButton';
import { FormInstance } from 'antd/lib/form';
import { PlusOutlined } from '@ant-design/icons';
import { toCurrency } from '../../../utils/utils';
import { AssetComponent } from '../../../services/assets';
import { useFormList } from '../../../hooks/useFormList';
import { shouldUpdateCompare } from 'utils/utils2';
import ParListSelect from 'components/ParListSelect';
import Value from 'components/Value';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AssetComponentModal from './AssetComponentModal';
import FormInput from 'components/FormInput';
import { isNil, sumBy } from 'lodash';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import ModalControllerNV from 'components/ModalControllerNV';
import Button from 'components/Button';

type AssetComponentsProps = {
  form: FormInstance;
  linkedCon?: boolean;
  phase: string;
  showAsModal?: boolean;
  iscreate?: boolean;
  status?: string;
  fromproposal?: boolean;
  action?:boolean
};
const AssetComponents = (props: AssetComponentsProps) => {
  const {
    action,
    form,
    linkedCon,
    phase,
    showAsModal,
    iscreate,
    status,
    fromproposal,
  } = props;

  const fieldName =
    phase === 'PROPOSAL' ? 'assetComponents' : 'finAssetComponents';

  const { add, remove } = useFormList(form, fieldName, {
    addAsFirst: true,
    idKey: 'compid',
  });

  if (form.getFieldValue(fieldName) === undefined) {
    form.setFieldsValue({
      [fieldName]: [],
    });
  }

  const [index, setIndex] = useState(
    form.getFieldValue([fieldName]).length - 1
  );
  const update = (item: AssetComponent) => {
    const values = form.getFieldValue(fieldName) as AssetComponent[];

    const newValues = values.map((elem, i) => {
      if (item.compid !== elem.compid) {
        return elem;
      }
      const updatedItem = { ...elem, ...item };

      return {
        ...updatedItem,
      };
    });
    let assetunitnetamount = sumBy(newValues, 'compnetamount');
    let assetqty =
      !isNil(form.getFieldValue('assetqty')) &&
      form.getFieldValue('assetqty') !== 0
        ? form.getFieldValue('assetqty')
        : 1;
    let assetnetamount = assetunitnetamount * assetqty;
    let assetfinamount = assetunitnetamount * assetqty;
    let assetunittaxamount = sumBy(newValues, 'comptaxamount');
    let assettaxamount = sumBy(newValues, 'comptaxamount') * assetqty;
    let assetunitgrossamount = sumBy(newValues, 'compgrossamount');
    let assetgrossamount = sumBy(newValues, 'compgrossamount') * assetqty;
    form.setFieldsValue({
      [fieldName]: newValues,
      assetqty: assetqty,
      assetunitnetamount,
      assetunittaxamount,
      assetunitgrossamount,
      assetnetamount,
      assetfinamount,
      assettaxamount,
      assetgrossamount,
    });
  };
  const addRow = (item: AssetComponent) => {
    add(item);
    const values = form.getFieldValue(fieldName) as AssetComponent[];

    const newValues = values.map((elem, i) => {
      if (item.compid !== elem.compid) {
        return elem;
      }
      const updatedItem = { ...elem, ...item };

      return {
        ...updatedItem,
      };
    });
    let assetunitnetamount = sumBy(newValues, 'compnetamount');
    let assetqty = !isNil(form.getFieldValue('assetqty'))
      ? form.getFieldValue('assetqty')
      : 1;
    let assetnetamount = assetunitnetamount * assetqty;
    
    let assetfinamount = assetunitnetamount * assetqty;
    let assetunittaxamount = sumBy(newValues, 'comptaxamount');
    let assettaxamount = sumBy(newValues, 'comptaxamount') * assetqty;
    let assetunitgrossamount = sumBy(newValues, 'compgrossamount');
    let assetgrossamount = sumBy(newValues, 'compgrossamount') * assetqty;
    form.setFieldsValue({
      [fieldName]: newValues,
      assetqty: assetqty,
      assetunitnetamount,
      assetunittaxamount,
      assetunitgrossamount,
      assetnetamount,
      assetfinamount,
      assettaxamount,
      assetgrossamount,
    });
  };

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'AssetCompTable.comptype',
        key: 'comptype',
        width: 100,
        render: (_, record, index) => {
          return (
            <Form.Item name={[fieldName, index, 'comptype']}>
              <ParListSelect parcode="COMPTYPE" disabled />
            </Form.Item>
          );
        },
        fixed: 'left',
      },
      {
        comcode: 'AssetCompTable.compdescription',
        key: 'compdescription',
        width: 300,
        render: (_value, _record, index) => (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <Form.Item shouldUpdate={shouldUpdateCompare([fieldName])}>
                {({ getFieldValue }) => {
                  return (
                    <FormInput
                      col
                      xs={24}
                      name={[fieldName, index, 'compdescription']}
                      noStyle
                    >
                      <a onClick={() => setVisible(action?false:true)}>
                        {getFieldValue([fieldName, index, 'compdescription'])}
                      </a>
                    </FormInput>
                  );
                }}
              </Form.Item>
            )}
            modal={({ setVisible, visible }) => (
              <AssetComponentModal
                onCancel={() => {
                  setVisible(false);
                }}
                onOk={(item) => {
                  update(item);
                  setVisible(false);
                }}
                visible={visible}
                addorupdate="UPDATE"
                currcode={form.getFieldValue('currcode')}
                formC={form}
                compid={_record.compid}
                record={_record}
                iscreate={iscreate}
                linkedCon={linkedCon}
                status={status}
                fromproposal={fromproposal}
              />
            )}
          />
        ),
      },

      {
        comcode: 'AssetCompTable.suppliername',
        key: 'suppliername',
        dataIndex: 'suppliername',
        width: 250,
      },
      {
        comcode: 'AssetCompTable.compnetamount',
        key: 'compnetamount',
        render: (_value, _record, index) => (
          <Form.Item name={[fieldName, index, 'compnetamount']}>
            <Value
              formatter={(value) =>
                toCurrency(value, form.getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? '')
              }
            />
          </Form.Item>
        ),
        width: 150,
      },
      {
        comcode: 'AssetCompTable.comptaxamount',
        key: 'comptaxamount',
        render: (_value, _record, index) => (
          <Form.Item name={[fieldName, index, 'comptaxamount']}>
            <Value
              formatter={(value) =>
                toCurrency(value, form.getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? '')
              }
            />
          </Form.Item>
        ),
        width: 150,
      },

      {
        comcode: 'AssetCompTable.compgrossamount',
        key: 'compgrossamount',
        render: (_value, _record, index) => (
          <Form.Item name={[fieldName, index, 'compgrossamount']}>
            <Value
              formatter={(value) =>
                toCurrency(value, form.getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? '')
              }
            />
          </Form.Item>
        ),
        fixed: 'right',
        width: 120,
      },
      {
        title: 'Actions',
        key: 'actions',
        render: (_value, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              remove(record.compid);
              setIndex(index - 1);
              const values = form.getFieldValue(fieldName) as AssetComponent[];
              let assetunitnetamount = sumBy(values, 'compnetamount');
              let assetqty = !isNil(form.getFieldValue('assetqty'))
                ? form.getFieldValue('assetqty')
                : 1;
              let assetnetamount = assetunitnetamount * assetqty;
              let assetunittaxamount = sumBy(values, 'comptaxamount');
              let assettaxamount = sumBy(values, 'comptaxamount') * assetqty;
              let assetunitgrossamount = sumBy(values, 'compgrossamount');
              let assetgrossamount =
                sumBy(values, 'compgrossamount') * assetqty;
              form.setFieldsValue({
                assetqty: assetqty,
                assetunitnetamount,
                assetunittaxamount,
                assetunitgrossamount,
                assetnetamount,
                assettaxamount,
                assetgrossamount,
              });
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [remove]
  );

  const title = (
    <>
      <Col span={10}></Col>
      <Form.Item
        noStyle
        shouldUpdate={shouldUpdateCompare([
          'assetnetamount',
          'assettaxamount',
          'assetgrossamount',
          'assetunitnetamount',
          'assetqty',
          'currcode',
        ])}
      >
        {({ getFieldValue }) => {
          return (
            <Space size={24}>
              <span style={{ color: '#668cff' }}>
              <GetLabel label='Unit Net:'/>  {' '}
                {toCurrency(
                  getFieldValue('assetunitnetamount'),
                  getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? ''
                )}
              </span>
              <span style={{ color: '#668cff' }}>
                <GetLabel label=' Qty:'/>  {' '} {getFieldValue('assetqty')}
              </span>
              <span style={{ color: '#668cff' }}>
                 <GetLabel label='Net:'/>  {' '}
                {toCurrency(
                  getFieldValue('assetnetamount'),
                  getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? ''
                )}
              </span>
              <span style={{ color: '#b3c6ff' }}>
              <GetLabel label='  Tax:'/>  {' '}
                {toCurrency(
                  getFieldValue('assettaxamount'),
                  getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? ''
                )}
              </span>
              <strong style={{ color: '#668cff' }}>
                <GetLabel label=' Gross:'/>  {' '}
                {toCurrency(
                  getFieldValue('assetgrossamount'),
                  getFieldValue('currcode') ?? localStorage.getItem('currcode') ?? ''
                )}
              </strong>
            </Space>
          );
        }}
      </Form.Item>
    </>
  );

  return (
    <Card title={<GetLabel label="assetComponents" style={{fontWeight:'bold',paddingLeft:15}} />}>
      <Form.Item noStyle shouldUpdate={shouldUpdateCompare('assetComponents')}>
        {({ getFieldValue }) => {

          return (
            <DataGrid
              title={title}
              columns={columns}
              dataSource={getFieldValue(fieldName)}
              rowKey="compid"
              hideFilters
              extraActions={!action&&
                <ModalControllerNV
                  content={({ setVisible, visible }) =>
                    (
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setVisible(true);
                        }}
                        comcode="add"
                      />
                    )
                  }
                  modal={({ setVisible, visible }) => (
                    <AssetComponentModal
                      onCancel={() => {
                        setVisible(false);
                      }}
                      onOk={(item) => {
                        addRow(item);
                        setVisible(false);
                      }}
                      visible={visible}
                      addorupdate="ADD"
                      currcode={form.getFieldValue('currcode')}
                      formC={form}
                      status={status}
                      fromproposal={fromproposal}
                    />
                  )}
                />
              }
            />
          );
        }}
      </Form.Item>
    </Card>
  );
};

export default AssetComponents;
